
import { useContext } from 'react'
import pattern from '../../assets/pattern.png'
import { DContext } from '../../context/DataContext'

export default function WhatNext() {
    const { setOpenForm } = useContext(DContext)

    return (
        <section className="bg-primary-800 relative py-4 md:py-0 h-[250px] sm:h-auto ">
            {/* Background Pattern */}
            <img src={pattern} alt="Pattern" className="w-full" />

            <div className=" px-3 sm:px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
                <div className="flex justify-center">

                    {/* CONTENT */}
                    <div className="  mx-auto max-w-7xl px-4 sm:px-6 absolute top-0  pt-4 sm:pt-10 md:pt-0 mt-4 md:mt-10 lg:mt-0 lg:top-[30%] ">
                        <h1 className="   text-center font-bold text-white  text-2xl sm:text-3xl md:text-4xl lg:text-6xl
          py-3 sm:py-4 "> Build What’s Next. Intelligently.
                        </h1>

                        <p className="   text-center font-secondary text-white  text-sm sm:text-base  md:text-lg  py-3  sm:py-5
          max-w-full  md:max-w-[700px] lg:max-w-[850px] mx-auto ">
                            From product engineering to intelligent automation, we partner with you
                            to design systems built for long-term business impact.
                        </p>

                        <div className="text-center">
                            <button
                                onClick={() => setOpenForm(true)}
                                className=" text-secondary-500 font-semibold text-xs sm:text-sm  md:text-base py-2 px-4 sm:py-2.5 sm:px-6 bg-white rounded-lg 
                            border border-secondary-500 hover:bg-secondary-500 hover:text-white transition duration-700">
                                Start Your Project
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </section>


    )
}

